import { createReducer, on } from "@ngrx/store";
import { AdminStore } from "../models/admin.model";
import { adminActions, adminApiActions } from "../actions/admin.actions";
import { adminUserAdapter } from "../adapters/admin/user.adapter";
import { adminSystemAdapter } from "../adapters/admin/event-system.adapter";
import { adminHostAdapter } from "../adapters/admin/event-host.adapter";
import { adminEventAdapter } from "../adapters/admin/event.adapter";
import { adminOrganiserAdapter } from "../adapters/admin/organiser.adapter";


const initialState: AdminStore = {
    events: adminEventAdapter.getInitialState(),
    archiveLoaded: false,
    currentLoaded: false,
    menu: {
        visible: false,
        event: false,
        organiser: false,
        admin: false
    },
    organisers: adminOrganiserAdapter.getInitialState(),
    eventHosts: adminHostAdapter.getInitialState(),
    eventsystems: adminSystemAdapter.getInitialState(),
    privilegedUsers: adminUserAdapter.getInitialState(),
    users: adminUserAdapter.getInitialState(),
    ticketTypes: []
}

export const adminReducer = createReducer(
    initialState,
    on(adminActions.changeMenuVisiblity, (state, { visibility }) => ({
        ...state,
        menu: {
            ...state.menu,
            visible: visibility
        }
    })),
    on(adminApiActions.fetchAllEvents, (state, { events }) => ({
        ...state,
        events: adminEventAdapter.setAll(events,state.events)
    })),
    on(adminApiActions.fetchEvent, (state, { event }) => ({
        ...state,
        events: adminEventAdapter.upsertOne(event,state.events)
    })),
    on(adminApiActions.fetchArchivedEvents, (state, { events }) => ({
        ...state,
        archiveLoaded: true,
        events: adminEventAdapter.upsertMany(events,state.events)
    })),
    on(adminApiActions.fetchEventHosts, (state, { eventHosts }) => ({
        ...state,
        eventHosts: adminHostAdapter.setAll(eventHosts,state.eventHosts)
    })),
    on(adminApiActions.fetchSinglePrivilegedUser, (state, user) => ({
            ...state,
            privilegedUsers: adminUserAdapter.upsertOne(user.user,state.privilegedUsers)
    })),
    on(adminApiActions.fetchSingleUser, (state, user) => ({
        ...state,
        users: adminUserAdapter.upsertOne(user.user,state.users)
    })),
    on(adminApiActions.updatedEventTicket, (state,update) => ({
        ...state,
        events: adminEventAdapter.updateOne(update.update,state.events)
    })),
    on(adminApiActions.createdEventTicket, (state,update) => ({
        ...state,
        events: adminEventAdapter.updateOne(update.update,state.events)
    })),
    on(adminApiActions.eventCreated, (state,data) => ({
        ...state,
        events: adminEventAdapter.addOne(data.lrpEvent,state.events)
    })),
    on(adminActions.updateEvent,(state,lrpEvent) => ({
        ...state,
        events: adminEventAdapter.updateOne(lrpEvent.update,state.events)
    })),
    on(adminApiActions.eventUpdated, (state,update) => ({
        ...state,
        events: adminEventAdapter.upsertOne(update.lrpEvent,state.events)
    })),
    on(adminApiActions.fetchTicketTypes, (state,data) => ({
        ...state,
        ticketTypes: data.ticketTypes
    })),
    on(adminApiActions.fetchOrganisers, (state,data) => ({
        ...state,
        organisers: adminOrganiserAdapter.setAll(data.organisers,state.organisers)
    })),
    on(adminApiActions.updateOrganiser, (state,update) => ({
        ...state,
        organisers : adminOrganiserAdapter.updateOne(update.update, state.organisers)
    })),
    on(adminApiActions.fetchEventBooking, (state,data) => ({
        ...state,
        events: adminEventAdapter.updateOne(data.update,state.events)
    }))
)